import React, { useState, useEffect } from "react";
import Select from "react-select";
import { Search } from 'lucide-react';
import classes from "./AccountApprovals.module.css"
import plus from "../../../../Assets/plus.svg"
import EyeIcon from "../../../../Assets/new-eye.svg"
import DeleteIcon from "../../../../Assets/new-delete.svg"
import PencilIcon from "../../../../Assets/pencil.svg"
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { RiDeleteBinLine } from "react-icons/ri";
import { Spinner, Badge, Button, Modal, Form, Alert } from 'react-bootstrap';
import CurrencyInput from 'react-currency-input-field';
import HeaderNav from "../../../Budget/Budget Dashboard/HeaderNav/HeaderNav";
import axios from "axios";
import { BASE_URL } from "../../../../Components/Styles/API/API";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

const Approved = () => {
  const [selectedOption, setSelectedOption] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [show, setShow] = useState(false);
  const [continentDescription, setContinentDescription] = useState("");
  const [selectedReportTo, setSelectedReportTo] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [show1, setShow1] = useState(false);
  const [continents, setContinents] = useState([]);
  const [regions, setRegions] = useState([]);
  const [provinces, setProvinces] = useState([]);
  const [accounts, setAccounts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedContinent, setSelectedContinent] = useState(null);
  const [selectedRegion, setSelectedRegion] = useState(null);
  const [selectedProvinceFilter, setSelectedProvinceFilter] = useState(null);
  const [selectedContinentFilter, setSelectedContinentFilter] = useState(null);
  const [selectedRegionFilter, setSelectedRegionFilter] = useState(null);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [bearer, setBearer] = useState('');
  const [selectedAccounts, setSelectedAccounts] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [perPage, setPerPage] = useState(100);
  const navigate = useNavigate();

  // Helper function to safely get field values
  const getFieldValue = (field) => {
    if (field == null) return '';
    if (typeof field === 'object') {
      return field.description || field.name || field.account_name || field.account_code || '';
    }
    return field.toString();
  };

  // Add the missing formatDate function
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';

    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      });
    } catch (error) {
      return 'N/A';
    }
  };

  // Get token from localStorage
  const readData = async () => {
    try {
      const value = await localStorage.getItem('userToken');
      if (value !== null) {
        setBearer(value);
      }
    } catch (e) {
      console.error('Failed to fetch token from storage');
    }
  };

  useEffect(() => {
    readData();
  }, []);

  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${bearer}`
  };

  // Fetch continents from API
  const fetchContinents = async () => {
    try {
      setLoading(true);
      setError("");

      if (!bearer) {
        setError("Please log in to access this resource");
        setLoading(false);
        return;
      }

      const response = await axios.get(`${BASE_URL}/continents`, { headers });

      if (response.data.status) {
        setContinents(response.data.data || []);
      } else if (Array.isArray(response.data)) {
        setContinents(response.data);
      } else if (response.data.data) {
        setContinents(response.data.data || []);
      } else {
        setContinents([]);
      }
    } catch (error) {
      console.error("Error fetching continents:", error);
      setContinents([]);
    }
  };

  // Fetch regions based on selected continent
  const fetchRegions = async (continentId) => {
    if (!continentId) {
      setRegions([]);
      return;
    }

    try {
      const response = await axios.get(`${BASE_URL}/continents/getcontinentregions?continent_id=${continentId}`, { headers });
      console.log("Regions API Response:", response.data);

      let regionsData = [];
      if (response.data.status && response.data.data) {
        if (Array.isArray(response.data.data)) {
          regionsData = response.data.data;
        } else if (response.data.data.regions && Array.isArray(response.data.data.regions)) {
          regionsData = response.data.data.regions;
        }
      } else if (Array.isArray(response.data)) {
        regionsData = response.data;
      } else if (response.data.data && Array.isArray(response.data.data)) {
        regionsData = response.data.data;
      }

      if (!Array.isArray(regionsData)) {
        console.error("Regions data is not an array:", regionsData);
        regionsData = [];
      }

      setRegions(regionsData);
    } catch (error) {
      console.error("Error fetching regions:", error);
      setRegions([]);
    }
  };

  // Fetch provinces based on selected region
  const fetchProvincesForFilter = async (regionId) => {
    if (!regionId) {
      setProvinces([]);
      return;
    }

    try {
      const response = await axios.get(`${BASE_URL}/regions/getprovincesregion?region_id=${regionId}`, { headers });
      console.log("Provinces API Response:", response.data);

      let provincesData = [];
      if (response.data.status) {
        if (response.data.data && response.data.data.provinces) {
          provincesData = response.data.data.provinces;
        } else if (Array.isArray(response.data.data)) {
          provincesData = response.data.data;
        } else {
          provincesData = response.data.data || [];
        }
      } else if (Array.isArray(response.data)) {
        provincesData = response.data;
      } else if (response.data.data) {
        provincesData = response.data.data || [];
      } else {
        provincesData = [];
      }

      if (!Array.isArray(provincesData)) {
        console.error("Provinces data is not an array:", provincesData);
        provincesData = [];
      }

      setProvinces(provincesData);
    } catch (error) {
      console.error("Error fetching provinces:", error);
      setProvinces([]);
    }
  };

  // Fetch accounts for the table with pagination
  const fetchAccounts = async (page = 1) => {
    try {
      setLoading(true);
      const response = await axios.get(`${BASE_URL}/account/all-approved?page=${page}&per_page=${perPage}`, { headers });
      console.log("Accounts API Response:", response.data);

      // Handle the nested response structure: response.data.data.data
      if (response.data.status && response.data.data) {
        let accountsData = [];
        let total = 0;

        // Extract accounts data based on the structure
        if (response.data.data.data && Array.isArray(response.data.data.data)) {
          accountsData = response.data.data.data;
          total = response.data.data.total || accountsData.length;
        }
        else if (Array.isArray(response.data.data)) {
          accountsData = response.data.data;
          total = accountsData.length;
        }
        else if (response.data.data.accounts && Array.isArray(response.data.data.accounts)) {
          accountsData = response.data.data.accounts;
          total = response.data.data.total || accountsData.length;
        }
        else {
          accountsData = [];
          total = 0;
        }

        setAccounts(accountsData);
        setTotalPages(response.data.data.last_page || Math.ceil(total / perPage));
        setCurrentPage(response.data.data.current_page || page);

        console.log("First account structure:", accountsData[0]);
      } else {
        setAccounts([]);
        setTotalPages(1);
        setCurrentPage(1);
      }
    } catch (error) {
      console.error("Error fetching accounts:", error);
      setAccounts([]);
      setTotalPages(1);
      setCurrentPage(1);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (bearer) {
      fetchContinents();
      fetchAccounts();
    }
  }, [bearer]);

  // Fetch regions when continent filter changes
  useEffect(() => {
    if (selectedContinentFilter) {
      fetchRegions(selectedContinentFilter.value);
    } else {
      setRegions([]);
      setSelectedRegionFilter(null);
      setSelectedProvinceFilter(null);
    }
  }, [selectedContinentFilter]);

  // Fetch provinces when region filter changes
  useEffect(() => {
    if (selectedRegionFilter) {
      fetchProvincesForFilter(selectedRegionFilter.value);
    } else {
      setProvinces([]);
      setSelectedProvinceFilter(null);
    }
  }, [selectedRegionFilter]);

  // Handle continent filter change
  const handleContinentChange = (selectedOption) => {
    setSelectedContinentFilter(selectedOption);
    setSelectedRegionFilter(null);
    setSelectedProvinceFilter(null);
  };

  // Handle region filter change
  const handleRegionChange = (selectedOption) => {
    setSelectedRegionFilter(selectedOption);
    setSelectedProvinceFilter(null);
  };

  // Handle province filter change
  const handleProvinceChange = (selectedOption) => {
    setSelectedProvinceFilter(selectedOption);
  };

  // Handle process button click
  const handleProcessAccounts = async () => {
    if (!selectedProvinceFilter) {
      Swal.fire({
        title: "Selection Required",
        text: "Please select continent, region and province to process accounts.",
        icon: "info",
        confirmButtonText: "OK",
      });
      return;
    }

    try {
      setIsLoading(true);
      const response = await axios.get(`${BASE_URL}/provinces/get-province-accounts`, {
        params: {
          province_id: selectedProvinceFilter.value
        },
        headers
      });

      console.log("Province Accounts API Response:", response.data);

      if (response.data.status) {
        Swal.fire({
          title: "Success!",
          text: `Processing accounts for ${selectedProvinceFilter.label}`,
          icon: "success",
          confirmButtonText: "OK",
        });
        // Refresh accounts after processing
        fetchAccounts(currentPage);
      }
    } catch (error) {
      console.error("Error processing province accounts:", error);
      Swal.fire({
        title: "Error!",
        text: "Failed to process province accounts",
        icon: "error",
        confirmButtonText: "OK",
      });
    } finally {
      setIsLoading(false);
    }
  };

  // Handle checkbox selection
  const handleCheckboxChange = (accountId) => {
    setSelectedAccounts(prev => {
      if (prev.includes(accountId)) {
        return prev.filter(id => id !== accountId);
      } else {
        return [...prev, accountId];
      }
    });
  };

  const handleSelectAll = () => {
    if (selectedAccounts.length === filteredAccounts.length) {
      setSelectedAccounts([]);
    } else {
      setSelectedAccounts(filteredAccounts.map(account => account.id));
    }
  };

  // Bulk approve accounts
  const handleBulkApprove = async () => {
    if (selectedAccounts.length === 0) {
      Swal.fire("Info", "Please select at least one account to approve", "info");
      return;
    }

    try {
      setIsLoading(true);
      const response = await axios.post(`${BASE_URL}/account/bulk-approve`, {
        account_ids: selectedAccounts,
        status: 1
      }, { headers });

      if (response.data.status) {
        Swal.fire("Success", "Accounts approved successfully", "success");
        setSelectedAccounts([]);
        fetchAccounts(currentPage);
      }
    } catch (error) {
      Swal.fire("Error", error.response?.data?.message || "Failed to approve accounts", "error");
    } finally {
      setIsLoading(false);
    }
  };

  // Bulk disapprove accounts
  const handleBulkDisapprove = async () => {
    if (selectedAccounts.length === 0) {
      Swal.fire("Info", "Please select at least one account to disapprove", "info");
      return;
    }

    try {
      setIsLoading(true);
      const response = await axios.post(`${BASE_URL}/account/bulk-approve`, {
        account_ids: selectedAccounts,
        status: 2
      }, { headers });

      if (response.data.status) {
        Swal.fire("Success", "Accounts disapproved successfully", "success");
        setSelectedAccounts([]);
        fetchAccounts(currentPage);
      }
    } catch (error) {
      Swal.fire("Error", error.response?.data?.message || "Failed to disapprove accounts", "error");
    } finally {
      setIsLoading(false);
    }
  };

  // Get status badge
  // Get status badge - DEBUGGING VERSION
  const getStatusBadge = (status) => {
    console.log("Status value:", status, "Type:", typeof status);

    // Handle both string and number status
    if (status === 0 || status === "0") {
      return <Badge bg="warning">Pending</Badge>;
    } else if (status === 1 || status === "1") {
      return <Badge bg="success">Approved</Badge>;
    } else if (status === 2 || status === "2") {
      return <Badge bg="danger">Disapproved</Badge>;
    } else {
      return <Badge bg="secondary">Unknown ({String(status)})</Badge>;
    }
  };
  // Pagination handlers
  const handleFirstPage = () => {
    if (currentPage > 1) {
      fetchAccounts(1);
    }
  };

  const handleLastPage = () => {
    if (currentPage < totalPages) {
      fetchAccounts(totalPages);
    }
  };

  const handlePageClick = (page) => {
    if (page !== currentPage) {
      fetchAccounts(page);
    }
  };

  // Prepare options for react-select
  const continentOptions = Array.isArray(continents)
    ? continents.map(continent => ({
      value: continent.id,
      label: continent.description || 'Unnamed Continent'
    }))
    : [];

  const regionOptions = Array.isArray(regions)
    ? regions.map(region => ({
      value: region.id,
      label: region.description || 'Unnamed Region'
    }))
    : [];

  const provinceOptions = Array.isArray(provinces)
    ? provinces.map(province => ({
      value: province.id,
      label: province.description || 'Unnamed Province'
    }))
    : [];

  // Filter accounts based on search term - CORRECTED VERSION
  const filteredAccounts = Array.isArray(accounts)
    ? accounts.filter(account => {
      if (!searchTerm) return true;

      const searchLower = searchTerm.toLowerCase();

      // Safely get values from each field using helper function
      const accountCode = getFieldValue(account?.account_code || account?.gl_code);
      const accountName = getFieldValue(account?.account_name || account?.created_by?.name);
      const accountType = getFieldValue(account?.account_type || account?.class?.description);
      const category = getFieldValue(account?.category);
      const subCategory = getFieldValue(account?.sub_category || account?.subcategory?.description);

      const fields = [accountCode, accountName, accountType, category, subCategory];

      return fields.some(field =>
        field.toLowerCase().includes(searchLower)
      );
    })
    : [];

  // Calculate display range for pagination
  const startItem = (currentPage - 1) * perPage + 1;
  const endItem = Math.min(currentPage * perPage, accounts.length);

  // Check if all pending accounts are selected
  const pendingAccounts = filteredAccounts.filter(account => account.status === 0);
  const isAllPendingSelected = pendingAccounts.length > 0 &&
    selectedAccounts.length === pendingAccounts.length &&
    pendingAccounts.every(account => selectedAccounts.includes(account.id));

  return (
    <div>
      <HeaderNav />

      <div className={classes.topContainer}>
        <div className={classes.topNavBars}>
          <Button className={classes.buttonsNav}>Remitances</Button>
          <Button className={classes.buttonsNav}>Petty Cash</Button>
          <Button className={classes.buttonsNav}>Supplier's Payment</Button>
          <Button className={classes.buttonsNav}>Customer's Leger</Button>
        </div>
        <div style={{ marginTop: 24 }} />
        <h3 className={classes.topText}>Approved Accounts</h3>
        <p className={classes.prgText}>View Approved Accounts.</p>

        {/* Filter Section */}
        <div className={classes.filterSection}>
          <div className={classes.filterContainer}>
            <div className={classes.filterItem}>
              <label className={classes.filterLabel}>Continent</label>
              <Select
                value={selectedContinentFilter}
                onChange={handleContinentChange}
                options={continentOptions}
                placeholder="Select Continent"
                isClearable
                className={classes.filterSelect}
              />
            </div>

            <div className={classes.filterItem}>
              <label className={classes.filterLabel}>Region</label>
              <Select
                value={selectedRegionFilter}
                onChange={handleRegionChange}
                options={regionOptions}
                placeholder="Select Region"
                isClearable
                isDisabled={!selectedContinentFilter}
                className={classes.filterSelect}
              />
            </div>

            <div className={classes.filterItem}>
              <label className={classes.filterLabel}>Province</label>
              <Select
                value={selectedProvinceFilter}
                onChange={handleProvinceChange}
                options={provinceOptions}
                placeholder="Select Province"
                isClearable
                isDisabled={!selectedRegionFilter}
                className={classes.filterSelect}
              />
            </div>

            <div className={classes.filterItem}>
              <label className={classes.filterLabel}>&nbsp;</label>
              <Button
                className={classes.manageButton}
                onClick={handleProcessAccounts}
                disabled={!selectedProvinceFilter || isLoading}
              >
                {isLoading ? <Spinner size="sm" /> : "Process"}
              </Button>
            </div>
          </div>

           <div className={classes.subContainer}>
          <div className={classes.searchInputWrapper}>
            <input
              type="text"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className={classes.searchInput}
              placeholder="Search accounts..."
            />
            {/* <Search className={classes.searchIcon} size={16} /> */}
          </div>
          <div className={classes.statCount}>
            <div className={classes.statConn}>
              <p className={classes.txtHd}>A/Cs</p>
              {loading ? (
                <div className={classes.skeleton} style={{ width: '40px', height: '24px', marginTop: '-10px', marginRight: 15 }}></div>
              ) : (
                <p className={classes.txtHds}>{accounts.length}</p>
              )}
            </div>
          </div>
        </div>
        </div>

       

        {/* Bulk Action Buttons - Show only when checkboxes are selected */}
        {selectedAccounts.length > 0 && (
          <div className={classes.bulkActions}>
            <Button
              variant="success"
              onClick={handleBulkApprove}
              disabled={isLoading}
              className="me-2"
            >
              {isLoading ? <Spinner size="sm" /> : "Approve Selected"}
            </Button>
            <Button
              variant="danger"
              onClick={handleBulkDisapprove}
              disabled={isLoading}
            >
              {isLoading ? <Spinner size="sm" /> : "Disapprove Selected"}
            </Button>
            <span className={classes.selectedCount}>
              {selectedAccounts.length} account(s) selected
            </span>
          </div>
        )}

        <div className={classes.tableContainer}>
          <table className={classes.tableTable}>
            <thead className={classes.tableHeader}>
              <tr>
                {/* <th>
                  <input
                    type="checkbox"
                    onChange={handleSelectAll}
                    checked={selectedAccounts.length > 0 && selectedAccounts.length === filteredAccounts.length}

                  />
                </th> */}
                <th>#</th>
                <th>Account Code</th>
                <th>Account Name</th>
                <th>Account Type</th>
                <th>Category</th>
                <th>Sub-Category</th>
                {/* <th>Status</th> */}
                <th>Approved by</th>
                <th>Approved Date</th>
                {/* <th>Directions</th> */}
              </tr>
            </thead>
            <tbody>
              {loading ? (
                Array.from({ length: 7 }).map((_, index) => (
                  <tr key={`skeleton-${index}`}>
                    <td className={classes.textby}>
                      <div className={classes.skeleton} style={{ width: '20px', height: '20px', borderRadius: '4px' }}></div>
                    </td>
                    <td className={classes.textby}>
                      <div className={classes.skeleton} style={{ width: '30px', height: '20px' }}></div>
                    </td>
                    <td className={classes.textby}>
                      <div className={classes.skeleton} style={{ width: '150px', height: '20px' }}></div>
                    </td>
                    <td className={classes.textby}>
                      <div className={classes.skeleton} style={{ width: '150px', height: '20px' }}></div>
                    </td>
                    <td className={classes.textby}>
                      <div className={classes.skeleton} style={{ width: '100px', height: '20px' }}></div>
                    </td>
                    <td className={classes.textby}>
                      <div className={classes.skeleton} style={{ width: '100px', height: '20px' }}></div>
                    </td>
                    <td className={classes.textby}>
                      <div className={classes.skeleton} style={{ width: '100px', height: '20px' }}></div>
                    </td>
                    <td className={classes.textby}>
                      <div className={classes.skeleton} style={{ width: '80px', height: '20px' }}></div>
                    </td>
                    <td className={classes.textby}>
                      <div className={classes.skeleton} style={{ width: '100px', height: '20px' }}></div>
                    </td>
                    <td className={classes.textby}>
                      <div className={classes.skeleton} style={{ width: '100px', height: '20px' }}></div>
                    </td>
                  </tr>
                ))
              ) : filteredAccounts.length > 0 ? (
                filteredAccounts.map((account, index) => (
                  <tr key={account.id || index}>
                    {/* <td className={classes.textby}>
                      <input
                        type="checkbox"
                        checked={selectedAccounts.includes(account.id)}
                        onChange={() => handleCheckboxChange(account.id)}

                      />
                    </td> */}
                    <td className={classes.textby}>{startItem + index}</td>
                    <td className={classes.textby}>
                      <span className={classes.statucColor}>
                        {getFieldValue(account.account_code || account.gl_code)}
                      </span>
                    </td>
                    <td className={classes.textby}>
                      {getFieldValue(account.account_name || account.created_by?.name)}
                    </td>
                    <td className={classes.textby}>
                      {getFieldValue(account.account_type || account.class?.description)}
                    </td>
                    <td className={classes.textby}>
                      {getFieldValue(account.category)}
                    </td>
                    <td className={classes.textby}>
                      {getFieldValue(account.sub_category || account.subcategory?.description)}
                    </td>
                    {/* <td className={classes.textby}>
                      {getStatusBadge(account.status)}
                    </td> */}
                    <td className={classes.textby}>
                      {getFieldValue(account.approved_by_name)}
                    </td>
                    <td className={classes.textby}>
                      {formatDate(account.updated_at)}
                    </td>
                    {/* <td className={classes.textby}>
                      {formatDate(account.direction)}
                    </td> */}
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="10" className="text-center p-4">
                    {searchTerm ? "No accounts found matching your search" : "No accounts available"}
                  </td>
                </tr>
              )}
            </tbody>
          </table>

          <div className={classes.paginationStyle}>
            <div className={classes.footerSubOne}>
              <button
                className={classes.btnFirst}
                onClick={handleFirstPage}
                disabled={currentPage === 1}
              >
                First
              </button>
              <span className={classes.ftOne}>
                {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
                  let pageNum;
                  if (totalPages <= 5) {
                    pageNum = i + 1;
                  } else if (currentPage <= 3) {
                    pageNum = i + 1;
                  } else if (currentPage >= totalPages - 2) {
                    pageNum = totalPages - 4 + i;
                  } else {
                    pageNum = currentPage - 2 + i;
                  }

                  return (
                    <button
                      key={pageNum}
                      className={`${classes.pageNumber} ${currentPage === pageNum ? classes.active : ''}`}
                      onClick={() => handlePageClick(pageNum)}
                    >
                      {pageNum}
                    </button>
                  );
                })}
              </span>
              <button
                className={classes.btnSec}
                onClick={handleLastPage}
                disabled={currentPage === totalPages}
              >
                Last
              </button>
            </div>
            <p className={classes.displayPag}>
              Displaying {startItem}-{endItem} of {accounts.length}
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Approved